import "./partials";
import "./blocks";
import "./lottie";
import AOS from "aos";

AOS.init();
